import React,{useState} from "react";
import { amenityCategories } from "../FilterConstants";
import {  AmenityGroup, getSelectedAmenityCount, getAmenityCategories } from "./AmenityHelper";


const FilterAmenities = ({ selectedAmenities, onAmenitiesChange }) => {
    const [currentCategory, setCurrentCategory] = useState(amenityCategories[0]);
    const totalCount = getSelectedAmenityCount(selectedAmenities);
    const categories = getAmenityCategories();
    
    const handleToggleAmenity = (category, amenityId) => {
      const currentAmenities = selectedAmenities[category] || [];
      const isSelected = currentAmenities.includes(amenityId);
      
      onAmenitiesChange({
        ...selectedAmenities,
        [category]: isSelected
          ? currentAmenities.filter(item => item !== amenityId)
          : [...currentAmenities, amenityId]
      });
    };
  
    return (
      <div className="space-y-[10px] sm:space-y-[12px]">
        <div className="text-[16px] sm:text-[18px] font-semibold">
          Amenities
          {totalCount > 0 && (
            <span className="ml-2 text-xs sm:text-sm bg-purple-100 text-purple-800 px-2 py-1 rounded-full">
              {totalCount} selected
            </span>
          )}
        </div>
        
        {/* Category selector tabs - keeping original UI style */}
        <div className="w-full flex flex-wrap gap-[8px] sm:gap-[10px] category-tabs-mobile">
          {categories.map(category => (
            <div
              key={category}
              onClick={() => setCurrentCategory(category)}
              className={
                currentCategory === category
                  ? "bg-[#dddddd] hover:bg-[#dddddd] cursor-pointer select-none px-[12px] sm:px-[14px] py-[6px] sm:py-[8px] rounded-[10px] sm:rounded-[12px] w-max border-[1px] border-[#E3E3E3] text-[12px] sm:text-sm category-tab-mobile"
                  : "hover:bg-[#dddddd] cursor-pointer select-none px-[12px] sm:px-[14px] py-[6px] sm:py-[8px] rounded-[10px] sm:rounded-[12px] w-max border-[1px] border-[#E3E3E3] text-[12px] sm:text-sm category-tab-mobile"
              }
            >
              {category}
              {selectedAmenities[category]?.length > 0 && (
                <span className="ml-1 bg-[#5b1dee] text-white text-xs px-1.5 py-0.5 rounded-full">
                  {selectedAmenities[category].length}
                </span>
              )}
            </div>
          ))}
        </div>
        
        {/* Amenities for selected category */}
        <div className="gap-[8px] sm:gap-[10px] p-[8px] sm:p-[10px] max-h-[200px] sm:max-h-[250px] overflow-y-auto amenity-grid-mobile">
          <AmenityGroup
            category={currentCategory}
            selectedAmenities={selectedAmenities}
            onToggleAmenity={handleToggleAmenity}
          />
        </div>
      </div>
    );
  };
  
  export default FilterAmenities;